/**
 * React Native Web Compatibility Fixes
 * 
 * This file contains fixes and workarounds for React Native Web compatibility issues,
 * particularly for deprecation warnings from third-party libraries like React Navigation.
 */

import { Platform } from 'react-native';

/**
 * Apply React Native Web compatibility fixes
 */
export const applyWebCompatibilityFixes = () => {
  if (Platform.OS !== 'web') return;

  // Fix for React Navigation shadow warnings
  // This is a temporary workaround until React Navigation updates their web styles
  const style = document.createElement('style');
  style.textContent = `
    /* Suppress React Navigation deprecated shadow warnings in web */
    .react-navigation-stack-card {
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1) !important;
    }
    
    /* Ensure pointer events work correctly in web */
    [data-react-navigation-stack] {
      pointer-events: auto !important;
    }
  `;
  
  document.head.appendChild(style);
  console.log('🔧 Applied React Native Web compatibility fixes');
};

/**
 * Initialize all web-specific fixes
 */
export const initializeWebFixes = () => {
  if (Platform.OS === 'web') {
    applyWebCompatibilityFixes();
  }
};